import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { useState } from "react";
import { download } from "utils/http";

function AmazonButton({ invoiceNumber, shipmentId }) {
  const [loading, setLoading] = useState(false);

  function onClickHandler() {
    setLoading(true);
    download(
      `/shipment/${shipmentId}/us-amazon/xlsx/`,
      `US Commercial invoice Packing List - ${invoiceNumber.replace("/", "_")}.xlsx`,
      {},
    )
      .catch((err) => Alert("error", String(err)))
      .finally(() => setLoading(false));
  }

  return (
    <Button loading={loading} onClick={onClickHandler}>
      US Amazon Document
    </Button>
  );
}

export default AmazonButton;
